import React, { useState} from 'react';
import axios from 'axios';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
//import { red } from '@mui/material/colors';
const countries = [ "Algeria","Afghanistan","Angola","Argentina","Australia","Austria","Belgium","Bolivia","Brazil","Bulgaria","Canada","Chile","China","Columbia","Congo","Czech Republic","Denmark","France","Germany","Indonesia","Italy","Laos","Madagascar","Mexico","Morocco","Namibia","Norway","Other Origin","Pakistan","Russia","South Africa","Tanzania","United States","Uruguay","Zambia","Peru","India","Spain"]
const min_stone_color = [ "Black","Blue","Brown","Gold","Green","Grey","Orange","Pink","Purple","Rainbow","Red","White","Yellow","Transparent","Smoky","Clear","Fluorescent","Silver"]
const product_type = [ "Aventurine","Man-Made Quartz","Man-Made Opal","Man-Made Topaz","Paradoxides Fossil","Mosasaur Tooth Fossil","Orthocera Fossil","Coprolite Fossil","Fish Fossil","Crocodile Tooth Fossil","Ammonite Fossil","Amethyst Geode","Tanzanite","Amazonite","Smoky Quartz","Rutilated Quartz","Rose Quartz","Prehnite Quartz","Clear Quartz","Celestite","Malachite","Spinel","Balochistan Fluorite","Hemimorphite","Labradorite","Morocco Vanadinite","Calcite","Quartz Calcite","Fujian Calcite","Clear Calcite","Cobalto Calcite","Stalactite Stalagmite Calcite","Leiping Calcite","Sodalite","Skutterudite","Galena","Astrophyllite","Petrified Wood","Peridot","Atacamite","Plumbogummite","Brochantite","Aquamarine","Heulandite","Jade","Yellow Jade","Chalcedony","Agate","Carnelian","Grape Agate","Tourmaline","Colored Tourmaline","Black Tourmaline","Muscovite","Dolomite","Howlite","White Howlite","Scheelite","Cerussite","Garnet","Spessartine Garnet","Lab Quartz","Green Calcite Fluorite","Chrysocolla","Sulfur","Jasper","Dalmatian Jasper"," Jasper","Pyrrhotite","Pyromorphite","Apatite","Emerald","Vesuvianite","Amethyst","Banded Amethyst","Veracruz Amethyst","Kunzite","Ruby","Unakite","Epidote","Turquoise","White Turquoise","Chrysoprase","Onyx","Chrysanthemum Stone","Siderite","Rhodochrosite","Fluorite","Inner Mongolia Fluorite","Tanzanite Fluorite","Manaoshan Fluorite","Yaogangxian Fluorite","botryoidal fluorite","Clear Fluorite","Xianghualing Fluorite","Sapphire","Kyanite","Azurite","Rhodonite","Tiger eye","Serpentine","Opal","Bloodstone","Hematite","Pyrolusite","Stilbite","Selenite","Barite","GoldStone","Goethite","Vanadinite","Autunite","Wolframite","Erythrite","Wulfenite","Iron Ore","Fuchsite","Lepidolite","Zircon","Rosasite","Feldspar","Sphalerite","Alabaster","Aragonite","Lapis Lazuli","Citrine","Topaz","Pyrite","Spain Pyrite","Chalcopyrite Peacock Ore","Mahogany Obsidian","Snowflake Obsidian","Septarian","Yellow Agate","Crazy Agate"," Glaucophane","Qinghai Jade","Kambaba Jasper","Rainbow Labradorite","Silver Labradorite"]
const product_shape = ["Single point","Double point","Angel","Apple","Bear","Bird","Cat","Cube","Deer","Dinosaur","Dog","Dragon","Eagle","Egg","Elephant","Horse","Heart","Mouse","Natural","Oblisk","Diamond octahedron","Owl","Pig","Pipe","Palm stone","Pyramid","Rabbit","Skull","Sphere","Tiger","Turtle","Unicorn","Massage wand","Bracelet","Necklace","Lotus","Slabs","Yoni Ball","Tower","Massage Roller"]

function NewPage() {
  const [formData, setFormData] = useState({ password: '', sku: '' });
  var buttonName = "";
  const [status, setStatus] = useState("Waiting for updates");
  const [files, setUploadFile] = useState({});



//this part still has issues, and we will need to add "publish to sellbrite query"
  const handleSubmit = (event) => {
    event.preventDefault();
    // check which button was pressed
    if (buttonName === "draft-button"){
      console.log("draft-button");
      saveToDraft();
    }
    else if (buttonName === "complete-button"){
      console.log("complete-button");
      publishProduct();
    }
  }
  //
  
  const handleChangeFiles = (event) => {
    setUploadFile(event.target.files);
  }

  const publishProduct = () => {
    //console.log(formData);

    const formDataFULL = new FormData();

    for (let i = 0 ; i < files.length ; i++) {
      formDataFULL.append("files", files[i]);
    }

    for (let i = 0; i < Object.keys(formData).length; i++){
      formDataFULL.append(Object.keys(formData)[i], formData[Object.keys(formData)[i]]);
    }
    //console.log(Object.keys(formData));

    //console.log(formDataFULL.getAll("files"));
    for (var value of formDataFULL.values()) {
      console.log(value);
   }


    axios({
      method: "POST",
      url: "https://flamingyetis.com/newProducts",
      data: formDataFULL,
      headers: { "Content-Type":  "multipart/form-data"}
    })
      .then(function (response) {
        console.log(response);
        setStatus(response.data.added)
      })
      .catch(function (response) {
        console.log(response);
      });
  }
  
  const saveToDraft = () => {
    //console.log(formData);

    const formDataFULL = new FormData();

    for (let i = 0 ; i < files.length ; i++) {
      formDataFULL.append("files", files[i]);
    }

    for (let i = 0; i < Object.keys(formData).length; i++){
      formDataFULL.append(Object.keys(formData)[i], formData[Object.keys(formData)[i]]);
    }
    //console.log(Object.keys(formData));

    //console.log(formDataFULL.getAll("files"));
    for (var value of formDataFULL.values()) {
      console.log(value);
   }


    axios({
      method: "POST",
      url: "https://flamingyetis.com/new",
      data: formDataFULL,
      headers: { "Content-Type":  "multipart/form-data"}
    })
      .then(function (response) {
        console.log(response);
        setStatus(response.data.added)
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  }   
  return ( 
    <div className="container">
      <h1>Locco Decor New Product Page</h1>
      <form onSubmit={handleSubmit}> 
        <div className="container"> 
          <br></br>
          <h2>Required Information/必填信息</h2>
          <br></br>
          <div className="row">
            <div className="col-md-4 mb-3">
              <div className="form-group required">
                 <label className="control-label">Password 密码&nbsp;</label>
                  <input type="text" className="form-control" id="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
                </div>
            </div>   
            <div className="col-md-4 mb-3">    
              <div className="form-group required">
                 <label className="control-label">Batch Number 批次&nbsp;</label>
                 <input type="text" className="form-control" id="mineral-batch-number" name="mineral-batch-number" placeholder="Mineral Batch Number" value={formData.min_batch_num} onChange={handleChange} required/>
                </div>
            </div>   
            <div className="col-md-4 mb-3">  
              <div className="form-group required" >
                <label className="control-label">SKU&nbsp;</label>
                <input type="text" className="form-control" id="sku" placeholder="SKU" name="sku" value={formData.sku} onChange={handleChange} required />
              </div>
            </div>
          </div>
        </div>
        <br></br>        
        <div className="container">
        <h2>Basic information 基本信息</h2>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label>Invoice Payment 支付状态</label>
              <select className="form-control custom-select" id="payment" name="payment" value={formData.payment} onChange={handleChange}>
                <option defaultValue>Choose 2选1</option>
                <option value="Paid">Paid 付过了</option>
                <option value="Unpaid">Unpaid 没支付</option>
              </select>
            </div>
            <div className="col-md-4 mb-3">
                <label>Stone Category 石头类别</label>
                <select className="form-control custom-select" id="stone-category" name="stone-category" value={formData.stone_category} onChange={handleChange}>
                  <option defaultValue>Choose...</option>
                  <option value="Specimen">Specimen 矿标</option>
                  <option value="Polished">Polished 抛光</option>
                  <option value="Material">Material 材料</option>
                  <option value="Jewelry">Jewelry 珠宝</option>
                  <option value="livesale">Livesale</option>
                  <option value="Other">Other 其他</option>
                </select>           
            </div>
            <div className="col-md-4 mb-3">
              <label>Mineral Stone Color 颜色</label>
              <Autocomplete autoSelect freeSolo id="mineral-stone-color" options={min_stone_color} renderInput={(params) => <TextField {...params} label="Mineral Stone Color" size="small"/>} name="mineral-stone-color"  value={formData.min_color}  onChange={(event, newValue) => {setFormData({ ...formData, "mineral-stone-color": newValue })}}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Mineral Stone Type 类别</label>
              <Autocomplete autoSelect freeSolo id="mineral-stone-type" name="mineral-stone-type" value={formData.min_stone_type} options={product_type} renderInput={(params) => <TextField {...params} size="small" label="Mineral Stone Type" />} onChange={(event, newValue) => {setFormData({ ...formData, "mineral-stone-type": newValue })}} />
            </div>
            <div className="col-md-6 mb-3">
              <label>Mineral Stone Shape 形状</label>
              <Autocomplete autoSelect freeSolo id="mineral-stone-shape" name="mineral-stone-shape" value={formData.min_stone_shape} options={product_shape} renderInput={(params) => <TextField {...params} size="small" label="Mineral Stone Shape" />} onChange={(event, newValue) => {setFormData({ ...formData, "mineral-stone-shape": newValue })}} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Brief Description 描述</label>
              <input type="text" className="form-control" id="brief-description" placeholder="description" name="brief-description" value={formData.brief_description} onChange={handleChange}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Video Link 视频链接</label>
              <input type="text" className="form-control" id="vl" placeholder="Video Link" name="vl" value={formData.vl} onChange={handleChange}/>
            </div>
            <div className="col-md-6 mb-3">
              <label>Picture Links 图片链接</label>
              <input type="text" className="form-control" id="img-h" placeholder="Picture Links" name="img-h" value={formData.img_h} onChange={handleChange}/>
            </div>
          </div>
          <div className='row'>
            <label className='col-md-6 mb-3'>File Upload
            <input type="file" className="form-control" id="files" name="files" multiple accept="image/png, image/jpeg, image/jpg, video/*" onChange={handleChangeFiles}></input>
            </label>
          </div>
          <div className="row">
            <div className="col-md-3 mb-3">
            <div className="form-group required">
             <label className="control-label">Stock/库存&nbsp;</label>
              <input type="number" min="0" className="form-control" id="available-stock" name="available-stock" placeholder="available stock" value={formData.a_stock} onChange={handleChange}/>
            </div></div>
            <div className="col-md-3 mb-3">
                <label>Origin Country国家</label>
                <Autocomplete id="origin-country" options={countries} renderInput={(params) => <TextField {...params} label="Origin" size="small"/>} name="origin-country" value={formData.origin_c} onChange={(event, newValue) => {setFormData({ ...formData, "origin-country": newValue })}} />
            </div>
            <div className="col-md-3 mb-3">
              <label>Origin Add-on</label>
              <input type="text" className="form-control" id="origin-secondary" placeholder="origin-secondary" name="origin-secondary" value={formData.origin_sec} onChange={handleChange}/>
            </div>
            <div className="col-md-3 mb-3">
              <label>Mineral Grade 等级</label>
              <select className="form-control custom-select" id="mineral-grade" name="mineral-grade" value={formData.min_grade} onChange={handleChange}>
                  <option defaultValue>Choose...</option>
                  <option value="A">Grade A</option>
                  <option value="B">Grade B</option>
                  <option value="C">Grade C</option>
                  <option value="D">Grade D</option>
                  <option value="E">Grade E</option>
                </select>   
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 mb-3">
              <label>Length(cm) 最长边</label>
              <input type="number" step="0.01" min="0" className="form-control" id="length-cm" name="length-cm" placeholder="Length(cm)" value={formData.len} onChange={handleChange}/>
            </div>
            <div className="col-md-3 mb-3">
              <label>Width(cm) 中间</label>
              <input type="number" step="0.01" min="0" className="form-control" id="width-cm" name="width-cm" placeholder="Width(cm)" value={formData.wd} onChange={handleChange}/>
            </div>
            <div className="col-md-3 mb-3">
              <label>Height(cm) 最短边</label>
              <input type="number" step="0.01" min="0" className="form-control" id="height-cm" name="height-cm" placeholder="Height(cm)" value={formData.ht} onChange={handleChange}/>
            </div>
            <div className="col-md-3 mb-3">
              <label>Weight(g) 重量克</label>
              <input type="number" step="0.01" min="0" className="form-control" id="weight-g" name="weight-g" placeholder="Weight(g)" value={formData.wt} onChange={handleChange}/>
            </div>
          </div>     
        </div>
        <div className="container">
          <h2>Price related 价格相关</h2>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label>Cost 成本</label>
              <input type="number" step="0.01" min="0" className="form-control" id="cost" name="cost" placeholder="Cost" value={formData.in_cost} onChange={handleChange}/>
            </div>
            <div className="col-md-4 mb-3">
              <label>Cost/kg 成本/公斤</label>
              <input type="number" step="0.01" min="0" className="form-control" id="cost-kg" name="cost-kg" placeholder="Cost/kg" value={formData.cost_kg} onChange={handleChange}/>
            </div>
            <div className="col-md-4 mb-3">
              <label>wholesale price 批发价</label>
              <input type="number" step="0.01" min="0" className="form-control" id="wholesale-price" name="wholesale-price" placeholder="Wholesale Price" value={formData.whl_price} onChange={handleChange}/>
            </div>
            </div>
            <div className="row">
            <div className="col-md-6 mb-3">
              <label>Wholesale Price/kg 批发价/公斤</label>
              <input type="number" step="0.1" min="0" className="form-control" id="wholesale-price-kg" name="wholesale-price-kg" placeholder="Wholesale Price/kg" value={formData.whl_price_kg} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
            <div className="form-group required">
              <label className="control-label">Price 售价&nbsp;</label>
              <input type="number" step="0.01" min="0" className="form-control" id="price" name="price" placeholder="Price" value={formData.in_price} onChange={handleChange}/>
            </div>
            </div>
          </div>
        </div>
        <div className="container">
          <h2>Location 位置</h2>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label>Box Number 盒子编号</label>
              <input type="text" className="form-control" id="box-number" name="box-number" placeholder="Box Number" value={formData.box_num} onChange={handleChange}/>
            </div>
            <div className="col-md-4 mb-3">
              <label>Locations 货架</label>
              <input type="text" className="form-control" id="locations" name="locations" placeholder="Locations" value={formData.loc} onChange={handleChange}/>
            </div>
          </div>
        </div>
        <button className="button-85" onSubmit={handleSubmit} onClick={() => {buttonName= "draft-button"}} >save to draft</button>
        <button className="button-85" onSubmit={handleSubmit} onClick={() => {buttonName="complete-button"}}>submit to complete</button>
        <br></br>
        <br></br>
        <div className="col-md-6 mb-3"><h2>{status}</h2></div>
      </form>
    </div>
  )
}

export default NewPage;
